import React from "react";

import { Modal, Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import { Button, ButtonWrapper } from "ds/Button";

type ModalConfirmLeaveFormProps = {
  title?: string;
  isOpen: boolean;
  closeModal: () => void;
  continueFunction: () => void;
  cancelFunction: () => void;
};

const ModalConfirmLeaveForm = ({
  title,
  closeModal,
  isOpen,
  continueFunction
}: ModalConfirmLeaveFormProps) => {
  const intl = useIntl();

  return (
    <Modal
      isOpen={isOpen}
      size="small"
      onOpenChange={closeModal}
      handleClose={closeModal}
    >
      <Typography.Title tag="h3">
        {title ??
          intl.formatMessage({
            id: "modal.confirm.leave.form.title",
            defaultMessage: "Are you sure you want to leave?"
          })}
      </Typography.Title>
      <Typography.BodyText>
        {intl.formatMessage({
          id: "modal.confirm.leave.form.detail",
          defaultMessage:
            "There are unsaved changes in this form that could be lost."
        })}
      </Typography.BodyText>
      <ButtonWrapper justifyContent="end" spacing="default">
        <Button
          id="continue-confirm-modal-button"
          variant="secondary"
          onClick={() => {
            continueFunction();
            closeModal();
          }}
        >
          {intl.formatMessage({ id: "continue" })}
        </Button>
        <Button
          id="form-return-modal-button"
          type="submit"
          onClick={() => closeModal()}
        >
          {intl.formatMessage({ id: "return_form" })}
        </Button>
      </ButtonWrapper>
    </Modal>
  );
};

export default ModalConfirmLeaveForm;
